import { FC } from 'react'

import { Header } from 'components'
import { Page, Divider } from 'common'
import { REACT_QUERY_KEYS, Routes } from 'common/constants'

import { useQueryClient } from '@tanstack/react-query'

import { TransactionalNotification } from '../../transactional-notification/TransactionalNotification'
import { DisableAllNotificationsBottomsheet } from '../../disable-all-notifications-bottomsheet/components/DisableAllNotificationsBottomsheet'
import { ProductScreen } from '../types'
import { ProductView } from './ProductView'

interface ProductProps {
  screen: ProductScreen
}

export const Product: FC<ProductProps> = ({ screen }) => {
  const queryClient = useQueryClient()

  if (screen.status !== 'ready') return <>{screen.fallback}</>

  const { productContent, communications, productId } = screen
  const { title, transactionalNotificationsSection, marketingNotificationsSection, alertSection } =
    productContent

  return (
    <Page>
      <Header
        title={title}
        showHomeIcon
        homeIconRoute={Routes.HOME}
        onClickLeftIcon={() => {
          queryClient.invalidateQueries({
            queryKey: [REACT_QUERY_KEYS.PURPOSES, REACT_QUERY_KEYS.US_PURPOSES],
          })
        }}
      />
      {transactionalNotificationsSection && (
        <TransactionalNotification
          titulo={transactionalNotificationsSection.title}
          descricao={transactionalNotificationsSection.details}
        />
      )}
      {transactionalNotificationsSection && <Divider $marginBottomPx={24} />}
      <ProductView
        marketingNotificationsSection={marketingNotificationsSection}
        alertSection={alertSection}
        hasTransactionalNotifications={!!transactionalNotificationsSection}
        communications={communications}
      />
      <DisableAllNotificationsBottomsheet producId={productId} />
    </Page>
  )
}
